import tigerFactory, { TigerTokenAuthProvider } from "@gooddata/sdk-backend-tiger";

export const backend = tigerFactory()
    .onHostname(process.env.REACT_APP_GOOD_DATA_HOST_NAME) // this should be the domain where the GoodData Cloud or GoodData.CN is hosted
    .withAuthentication(new TigerTokenAuthProvider(process.env.REACT_APP_TIGER_API_TOKEN));